import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import OrgUsersTab from '../../components/admin/OrgUsersTab';
import OrgReportsTab from '../../components/admin/OrgReportsTab';
import OrgCompaniesTab from '../../components/admin/OrgCompaniesTab';
import OrgTimelineTab from '../../components/admin/OrgTimelineTab';

const TABS = ['Overview', 'Users', 'Reports', 'Companies', 'Timeline'];

export default function OrgDetail() {
  const { orgId } = useParams();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Overview');

  useEffect(() => {
    setLoading(true);
    adminApi.getOrgDetail(orgId)
      .then(setOrg)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [orgId]);

  if (loading) return <div className="p-6 text-gray-500">Loading...</div>;
  if (!org) return <div className="p-6 text-red-500">Organization not found.</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">{org.orgName || org.name}</h1>
      <p className="text-gray-500 mb-6">Organization ID: {orgId}</p>

      {/* Tab navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="flex space-x-6">
          {TABS.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === 'Overview' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Object.entries(org).map(([key, value]) => {
            if (value && typeof value === 'object') return null;
            return (
              <div key={key} className="bg-white border border-gray-200 rounded-lg p-4">
                <dt className="text-xs font-medium text-gray-500 uppercase tracking-wide">{key}</dt>
                <dd className="mt-1 text-sm text-gray-900">
                  {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : (value ?? '-')}
                </dd>
              </div>
            );
          })}
        </div>
      )}
      {activeTab === 'Users' && <OrgUsersTab orgId={orgId} />}
      {activeTab === 'Reports' && <OrgReportsTab orgId={orgId} />}
      {activeTab === 'Companies' && <OrgCompaniesTab orgId={orgId} />}
      {activeTab === 'Timeline' && <OrgTimelineTab orgId={orgId} />}
    </div>
  );
}
